import { isNullOrUndefined } from './null-safety.js';

export enum LogLevel {
  Debug,
  Info,
  Warning,
  Error,
  Exception,
  Fatal,
}

const logLevelToInt = new Map<LogLevel, number>([
  [LogLevel.Debug, 0],
  [LogLevel.Info, 1],
  [LogLevel.Warning, 2],
  [LogLevel.Error, 3],
  [LogLevel.Exception, 4],
  [LogLevel.Fatal, 5],
]);

const intToLogLevel = new Map<number, LogLevel>([
  [0, LogLevel.Debug],
  [1, LogLevel.Info],
  [2, LogLevel.Warning],
  [3, LogLevel.Error],
  [4, LogLevel.Exception],
  [5, LogLevel.Fatal],
]);

const logLevelToString = new Map<LogLevel, string>([
  [LogLevel.Debug, 'DEBUG'],
  [LogLevel.Info, 'INFO'],
  [LogLevel.Warning, 'WARNING'],
  [LogLevel.Error, 'ERROR'],
  [LogLevel.Exception, 'EXCEPTION'],
  [LogLevel.Fatal, 'FATAL'],
]);

const stringToLogLevel = new Map<string, LogLevel>([
  ['DEBUG', LogLevel.Debug],
  ['INFO', LogLevel.Info],
  ['WARNING', LogLevel.Warning],
  ['ERROR', LogLevel.Error],
  ['EXCEPTION', LogLevel.Exception],
  ['FATAL', LogLevel.Fatal],
]);

export function getPriorityFromLogLevel(logLevel: LogLevel): number {
  const result = logLevelToInt.get(logLevel);
  if(isNullOrUndefined(result)) {
    throw new Error('Unknown log level: ${logLevel}');
  }

  return result;
}

export function getLogLevelFromPriority(priority: number): LogLevel | null {
  return intToLogLevel.get(priority) ?? null;
}

export function getStringFromLogLevel(logLevel: LogLevel): string {
  const result = logLevelToString.get(logLevel);
  if(isNullOrUndefined(result)) {
    throw new Error('Unknown log level: ${logLevel}');
  }

  return result;
}

export function getLogLevelFromString(str: string): LogLevel | null {
  return stringToLogLevel.get(str) ?? null;
}
